import { Box } from "@mui/material"
import React from "react"
import "./index.scss"

type Props = {
  label: string
  value?: string
  tags?: any[]
}

const EmployeeDetailItem = ({ label, value, tags }: Props) => {
  return (
    <Box className="employee-info-item">
      <Box className="employee-info-item-label">{label}</Box>
      {value && <Box className="employee-info-item-value">{value}</Box>}
      {tags && (
        <Box className="employee-info-item-value">
          {tags.map((tag, index) => {
            return (
              <Box className="employee-info-tag-box" key={index}>
                {tag}
              </Box>
            )
          })}
        </Box>
      )}
    </Box>
  )
}

export default EmployeeDetailItem
